var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"solutions nav-spacer"},[_c('SolutionDashboardtPay',{attrs:{"id":"solutions-tpay-pg"}}),_c('SolutionTpayHighlights'),_c('SolutionTpayTestimonial'),_c('SolutionTpayVideos'),_c('SolutionTpayFeatures'),_c('SolutionTpayContact')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }